import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { 
  Box,
  Card,
  makeStyles, 
  Avatar, 
  Typography,  
} from '@material-ui/core';

import { AvatarWithoutPhoto } from '../Shared/AvatarWithoutPhoto';
import { history } from '../../helpers';


const useStyle = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center',
    display: 'flex',
    padding: theme.spacing(4),
    borderRadius: 8,
    border: '1px solid',
    borderColor: theme.palette.grey.main,
  },
  large: {
    width: theme.spacing(16),
    height: theme.spacing(16),
  },
  name: {
    marginTop: theme.spacing(2),
  },
  position: {
    marginTop: theme.spacing(1),
    color: theme.palette.grey.darkest,
  },
  perfil: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase'
  },
  cursor: {
    cursor: 'pointer'
  }
}));

function FeedIdentity() {
  const classes = useStyle();
  const user = useSelector((state) => state.user);
  const { t } = useTranslation();

  function goToProfile() {
    history.push(`/profile/${user._id}`);
  }

  return (
    <Card className={classes.root} elevation={0}>
      {user.attachment?.url ? (
        <Avatar 
          src={user.attachment.url} 
          className={clsx(classes.large, classes.cursor)} 
          onClick={goToProfile}
        />
      ) : (
        <AvatarWithoutPhoto 
          superLarge iconStyle={{ fontSize: 80 }} 
          onClick={goToProfile} 
        />
      )}

      <Typography 
        variant="h5" 
        component="h1" 
        className={classes.name}>
        <Box 
          fontSize={20} 
          fontWeight="600" 
          textAlign="center"
          className={classes.cursor}
          onClick={goToProfile}
        >
          {user.name}
        </Box>
      </Typography>
      <Typography
        variant="subtitle1"
        component="h3"
        className={classes.position}
      >
        <Box fontWeight="fontWeightMedium" textAlign="center" fontSize={14}>
          {user.position}
          {user.businessUnitLocal?.occupationArea?.name && (
            <Box>
              {t('em')} {user.businessUnitLocal?.occupationArea?.name}
            </Box>
          )}
        </Box>
      </Typography>
      <Typography variant="subtitle1" component="h3" className={classes.perfil}>
        <Box fontWeight="fontWeightBold" textAlign="center" fontSize={14}>
          {(user.typeProfile.type === 'manager') || 
            (user.typeProfile.type === 'admin') ? (
            <div>{user.typeProfile.description}</div>
          ): null
          }
        </Box>
      </Typography>
    </Card>
  );
}

export { FeedIdentity };
